import React, { useContext, useEffect, useState } from 'react';
import { Box, Icon, RowItem, Title1 } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import EnvironmentContext from '../../../../contexts/EnvironmentContext';

import AutosFeedsBreadcrumbs from '../Breadcrumbs/AutosBreadcrumbs';
import AutosFeedsList from './AutosFeedsList';
import AutosFeedsSurveyLink from './AutosFeedsSurveyLink';

import Classes from './AutosFeeds.module.scss';
import LoginDialog from '../../../Homepage/components/LoginDialog/LoginDialog';

const SEEN_LOGIN_GATE = 'SeenLoginGate';

const wasLoginDialogShown = () =>
  !!(localStorage.getItem(SEEN_LOGIN_GATE) && localStorage.getItem(SEEN_LOGIN_GATE) === 'true');

export const AutosFeeds: React.FC = () => {
  const { t } = useI18nContext();
  const {
    isBot,
    hasConsentBannerBeenDismissed,
    userLoggedIn,
    links: { exploreMoreSurveyUrl },
    experiments: { isExploreMoreLinkSurveyEnable },
  } = useContext(EnvironmentContext);
  const [showLoginDialog, setShowLoginDialog] = useState(false);

  useEffect(() => {
    if (!isBot && !userLoggedIn && hasConsentBannerBeenDismissed && !wasLoginDialogShown()) {
      setShowLoginDialog(true);
      localStorage.setItem(SEEN_LOGIN_GATE, 'true');
    }
  }, [userLoggedIn, isBot, hasConsentBannerBeenDismissed]);

  return (
    <>
      <Box as="div" name="autosFeeds" className={Classes.autosFeeds}>
        <AutosFeedsBreadcrumbs />
        <Box as="div" name="titleContainer" className={Classes.titleContainer}>
          <Title1 className={Classes.title}>{t('homepage.exploreMore.title')}</Title1>
          <RowItem
            title={t('homepage.exploreMore.subtitle')}
            leftIcon={<Icon name="lightbulb" />}
            rightContent={
              isExploreMoreLinkSurveyEnable && <AutosFeedsSurveyLink exploreMoreSurveyUrl={exploreMoreSurveyUrl} />
            }
          />
        </Box>
        <AutosFeedsList setShowLoginDialog={setShowLoginDialog} />
        <Box as="div" name="auroFeedSurveySection" className={Classes.auroFeedSurveySection}>
          {isExploreMoreLinkSurveyEnable && <AutosFeedsSurveyLink exploreMoreSurveyUrl={exploreMoreSurveyUrl} />}
        </Box>
      </Box>
      {showLoginDialog && <LoginDialog onClose={setShowLoginDialog} />}
    </>
  );
};
